<app-navbar>
    <h2>{{'LOGIN.AUTH' | translate}}</h2>
</app-navbar>


<div class="login-area pt-100">
    <div class="container">
        <div class="row justify-content-center">

            <div class="col-12">
                <div class="row">
                    <div class="col-md-6 col-12 mx-auto">
                        <app-form-message [success]="formResponse"
                                          [customErrorMessage]="emailNotActive === true ? 'Contul nu este activ!' : userBlacklisted === true ? 'Acest user a fost blocat, motiv:' + blackListReason : 'Emailul sau parola nu sunt corecte.'"
                                          *ngIf="formSent"></app-form-message>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-12">
                <form #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)">
                    <div class="form-group">
                        <input type="email"
                               class="form-control"
                               placeholder="Email"
                               id="email"
                               ngModel
                               name="email"
                               required
                               email
                               #email="ngModel"
                        >
                    </div>
                    <!--Error Message-->
                    <div class="help-block" *ngIf="!email.valid && email.touched">
                        Te rog sa introduci un email valid!
                    </div>

                    <div class="form-group">
                        <input type="password"
                               class="form-control"
                               placeholder="{{'LOGIN.PASSWORD' | translate}}"
                               id="password"
                               ngModel
                               name="password"
                               #password="ngModel"
                               required>
                    </div>
                    <!--Error Message-->
                    <div class="help-block" *ngIf="!password.valid && password.touched">
                        {{'VALIDATION.REQUIRED' | translate}}
                    </div>

                    <div class="sub-login text-center mt-5">
                        <a routerLink="/parola-uitata" class="green-link d-inline-block">{{'LOGIN.PASSWORD_RESET' | translate}}</a>

                        <ul class="list-unstyled mt-3">
                            <li class="d-inline-block mr-3"><p class="m-0">{{'LOGIN.NEW_ACCOUNT' | translate}}</p></li>
                            <li class="d-inline-block"><a routerLink="/inregistrare" class="green-link">{{'LOGIN.SIGN_UP' | translate}}</a>
                            </li>
                        </ul>

                        <div class="text-center">
                            <button type="submit"
                                    class="green-button"
                                    [disabled]="!loginForm.valid">{{'LOGIN.AUTH' | translate}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!--        <div class="login-social">-->
        <!--            <a href="#"><i class="icofont-facebook"></i> Login With Facebook</a>-->
        <!--            <a class="login-google" href="#"><i class="icofont-google-plus"></i> Login With Google</a>-->
        <!--        </div>-->
    </div>
</div>
<app-footer></app-footer>
